import { Controller, useFormContext } from 'react-hook-form';

import { Checkbox, FormControlLabel } from '@mui/material';
import { FormControlLabelProps } from '@mui/material/FormControlLabel/FormControlLabel';

interface FlagCheckboxProps<T extends string>
  extends Omit<FormControlLabelProps, 'control'> {
  name: string;
  flag: T;
}

export const ControlledFlagCheckbox = <T extends string>({
  name,
  flag,
  ...formControlProps
}: FlagCheckboxProps<T>) => {
  const { control, watch, setValue } = useFormContext();
  const flags = watch(name);

  const handleCheckboxChange = (checked) => {
    if (checked) {
      setValue(name, [...flags, flag]);
    } else {
      setValue(
        name,
        flags.filter((item) => item !== flag)
      );
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <FormControlLabel
          {...formControlProps}
          control={
            <Checkbox
              {...field}
              checked={flags?.includes(flag)}
              onChange={(e) => handleCheckboxChange(e.target.checked)}
            />
          }
        />
      )}
    />
  );
};
